"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Helper to encode and decode LIA entity IDs used in GraphQL.
 */
// eslint-disable-next-line unicorn/no-static-only-class
class IdHelper {
    /**
     * Splits the id into a TypeAndId tuple.
     *
     *
     * @param id - The GraphQL ID
     * @return the decoded GraphQL ID as an object.
     */
    static idToTuple(id) {
        const [type, unscopedId] = id.split(':');
        return {
            type,
            id: unscopedId
        };
    }
    /**
     * Is this an optimistic ID.
     *
     *
     * @param id - The GraphQL ID
     * @return whether or not the ID is optimistic.
     */
    static isOptimistic(id) {
        return !id || id.endsWith('|temp');
    }
}
exports.default = IdHelper;
//# sourceMappingURL=IdConverter.js.map